import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getFaireDirectBrandToken } from "@faire/retailer-visitor-shared/serialized-data/getFaireDirectBrandToken";
import { BrandStore } from "@faire/retailer-visitor-shared/stores/domain/BrandStore";
import { logError } from "@faire/web--source/common/logging";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { action, computed, observable } from "mobx";
import { fromPromise } from "mobx-utils";
/**
 * @deprecated All new usages should use `useFaireDirectBrand` instead. This store
 * cannot be removed yet because the following dependencies need to be removed:
 * 1. `SignUpRoot`, `SignUpState`, and `SignUpFormState`: these will be removed soon
 * in favour for the new sign-up flow.
 * 2. `AppSignUpState` will be re-written to hooks in H2 2024.
 * 3. Finally, `ElevatePortalStore.test.ts`, `initializeApp.ts` (SPA), and `AppInitializer`
 * (Next) will be removed when this store is removed.
 */ export var ElevatePortalStore = /*#__PURE__*/ function() {
    "use strict";
    function ElevatePortalStore() {
        var _this = this;
        _class_call_check(this, ElevatePortalStore);
        var _this1 = this;
        this.init = function() {
            if (isWindowUndefined()) {
                return;
            }
            _this.initializeStorePromise = Promise.all([
                _this.fetchElevateBrand()
            ]).then(function() {});
        };
        // unused-class-members-ignore-next
        this.waitToInitialize = /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.initializeStorePromise
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        this.fetchElevateBrand = /*#__PURE__*/ _async_to_generator(function() {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!_this1.active) return [
                            3,
                            2
                        ];
                        _this1.elevateBrandResponse = fromPromise(BrandStore.get().getBrand(_this1.elevateBrandToken));
                        return [
                            4,
                            _this1.elevateBrandResponse
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        logError(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        makeObservable(this);
        this.init();
    }
    var _proto = ElevatePortalStore.prototype;
    // Duplicated for createStoreHook in useFaireDirectStore
    _proto.componentDidMount = function componentDidMount() {
        this.init();
    };
    _create_class(ElevatePortalStore, [
        {
            key: "elevateBrandToken",
            get: function get() {
                var _getFaireDirectBrandToken;
                return (_getFaireDirectBrandToken = getFaireDirectBrandToken()) !== null && _getFaireDirectBrandToken !== void 0 ? _getFaireDirectBrandToken : "";
            }
        },
        {
            key: "active",
            get: /**
     * @deprecated Use `isFaireDirectActiveInLoggedOutWithLocation` instead
     * for a more accurate determination of whether Faire Direct is active.
     */ function get() {
                return !!this.elevateBrandToken;
            }
        },
        {
            key: "faireDirectAlias",
            get: function get() {
                var _this_elevateBrand;
                return (_this_elevateBrand = this.elevateBrand) === null || _this_elevateBrand === void 0 ? void 0 : _this_elevateBrand.token_alias;
            }
        },
        {
            key: "elevateBrand",
            get: function get() {
                var _this_elevateBrandResponse;
                return (_this_elevateBrandResponse = this.elevateBrandResponse) === null || _this_elevateBrandResponse === void 0 ? void 0 : _this_elevateBrandResponse.case({
                    fulfilled: function(response) {
                        return response;
                    }
                });
            }
        }
    ]);
    return ElevatePortalStore;
}();
ElevatePortalStore.get = singletonGetter(ElevatePortalStore);
__decorate([
    observable
], ElevatePortalStore.prototype, "elevateBrandResponse", void 0);
__decorate([
    computed
], ElevatePortalStore.prototype, "faireDirectAlias", null);
__decorate([
    computed
], ElevatePortalStore.prototype, "elevateBrand", null);
__decorate([
    action
], ElevatePortalStore.prototype, "fetchElevateBrand", void 0);
